// extracted by mini-css-extract-plugin
export default {"pageWrap":"Pagination_pageWrap__Vup4K","active":"Pagination_active__THnKb"};